import { useEffect, useRef, useState } from "react";
import { Cliente } from "../../models/monitoreo/Cliente";
import { useForm } from "react-hook-form";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { InputComponent } from "../../components/InputComponent";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { Card } from "primereact/card";
import { Toolbar } from "primereact/toolbar";
import { Generico } from "../../components/Generico";
import { useToken } from "../../components/useToken";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
import '../../components/estilo.css';
import { CatalogoService } from "../../service/CatalogoService";
import { Calendar } from "primereact/calendar";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { FileUpload } from "primereact/fileupload";
import { FiltroUnicoAutocomplete, FiltroUnicoCatalogoFijo } from "../../components/ui/FiltrosGlobales";
import { useLazyParams } from "../../hooks/useLazyParams";
import { Column } from "primereact/column";
import { Menu } from "primereact/menu";
import { TablaDinamica } from "../../components/TablaDinamica";
pdfMake.addVirtualFileSystem(pdfFonts);

export const MonitoreoCliente = () => {

    const generic = Generico();
    const omodel = new Cliente();
    const [permss, setPermss] = useState(null);
    const defaultValues = generic.funDefault(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues, setValue, trigger } = useForm({ defaultValues, shouldTrim: true });
    const { getRol } = useToken();
    const monitoreoService = new MonitoreoService();
    const toast = useRef(null);
    const menuRef = useRef(null);
    const [item, setItem] = useState(null);
    const tablaEstado = useLazyParams({ modelo: omodel.model });
    const { inDrop, inText, inNumber } = InputComponent({ omodel, generic, errors, control, permss, id: getValues('id') });
    const [funcionalidades, setFuncionalidades] = useState([]);
    const [catalogos, setCatalogos] = useState({});
    const [dialogCliente, setDialogCliente] = useState(false);
    const [load, setLoad] = useState(false);
    const [loadExcel, setLoadExcel] = useState(false);
    const [loadPdf, setLoadPdf] = useState(false);
    const [ciudades, setCiudades] = useState([]);
    const [ecuadorId, setEcuadorId] = useState(null);
    const [ecuador, setEcuador] = useState(false);
    const catalogoSrv = new CatalogoService();
    const stepperRef = useRef(null);
    const [dialogReporte, setDialogReporte] = useState(false);
    const [diasMaxDescargaReporte, setDiasMaxDescargaReporte] = useState(31);
    const [inicio, setInicio] = useState(null);
    const [fin, setFin] = useState(null);
    const [tipo, setTipo] = useState(null);
    // Estados para la carga masiva
    const [esAdmin, setEsAdmin] = useState(false);
    const [empresaSelUpload, setEmpresaSelUpload] = useState(null);
    const [dialogUpload, setDialogUpload] = useState(false);
    const [archivoMasivo, setArchivoMasivo] = useState(null);
    const [loadUpload, setLoadUpload] = useState(false);
    const fileUploadRef = useRef(null);

    useEffect(() => {
        loadLazyData();
        // eslint-disable-next-line
    }, [tablaEstado.lazyParams]);

    const loadLazyData = () => {
        tablaEstado.setLoading(true);
        let _lazyParams = { ...tablaEstado.lazyParams };
        delete _lazyParams.rtipo;

        if (permss == null) {
            _lazyParams.rtipo = true;
        }
        if (getRol()) {
            _lazyParams.rol = getRol();
        }

        monitoreoService.listado('monitoreo/cliente/lista', { lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setFuncionalidades(res.data.funcionalidades);
            tablaEstado.setTotalRecords(res.data.total);
            tablaEstado.setData(res.data.registros);

            if (res.data.perss !== undefined) setPermss(res.data.perss);
            if (res.data.esAdmin !== undefined) setEsAdmin(res.data.esAdmin);

            if (res.data.tipo_identificacion) {
                setCatalogos(prev => ({ ...prev, tipo_identificacion: res.data.tipo_identificacion.map(p => ({ label: p.nombre, value: p.cat_id })) }));
            }
            if (res.data.catalogo_empresas) {
                const empresasFormateadas = res.data.catalogo_empresas.map(e => ({ label: e.razon_social, value: e.emp_id }));
                setCatalogos(prev => ({ ...prev, catalogo_empresas: empresasFormateadas }));
                // Autoselección si no es admin y solo tiene 1 empresa
                if (!res.data.esAdmin && empresasFormateadas.length === 1) {
                    setEmpresaSelUpload(empresasFormateadas[0].value);
                }
            }
            if (res.data.paises) {
                const paisesCatalogo = res.data.paises.map(p => ({ label: p.nombre, value: p.cat_id }));
                setCatalogos(prev => ({ ...prev, paises: paisesCatalogo }));
                const eq = paisesCatalogo.find(p => p.label === 'Ecuador');
                if (eq) setEcuadorId(eq.value);
            }
            if (res.data.provincias) {
                setCatalogos(prev => ({ ...prev, provincias: res.data.provincias.map(p => ({ label: p.nombre, value: p.cat_id })) }));
            }
            if (res.data.dias_max_descarga_reporte !== undefined) {
                setDiasMaxDescargaReporte(res.data.dias_max_descarga_reporte);
            }
        }).finally(() => {
            tablaEstado.setLoading(false);
        });
    }

    const buscarSugerenciasEmpresa = (texto) => {
        return monitoreoService.consultarInfo('administracion/catalogo/empresas', { texto }).then((res) => {
            return res.data
        }).catch((error) => {
            generic.funcSistemaError(error, toast);
            return [];
        }).finally(() => {

        });
    };

    const openNew = () => {
        reset(defaultValues);
        setDialogCliente(true);
    };

    const onSubmit = (data) => {
        data.es_ecuador = ecuador;
        if (getValues('id') == null) {
            setLoad(true);
            monitoreoService.nuevo(data, 'monitoreo/cliente/nuevo').then(res => {
                generic.funcSuccess(res, toast);
                setDialogCliente(false);
                loadLazyData();
            }).catch(err => {
                setLoad(false);
                generic.funcError(err, toast, setError);
            }).finally(() => {
                setLoad(false);
            });
        } else {
            setLoad(true);
            monitoreoService.editar(data, 'monitoreo/cliente/editar').then(res => {
                generic.funcSuccess(res, toast);
                setDialogCliente(false);
                loadLazyData();
            }).catch(err => {
                generic.funcError(err, toast, setError);
            }).finally(() => {
                setLoad(false);
            });
        }
    };

    const edit = () => {
        monitoreoService.consultar(item?.id, 'monitoreo/cliente/consulta').then(res => {
            const _item = res.data.cliente;
            const esEcuador = _item.pais_id === ecuadorId;
            setEcuador(esEcuador);
            if (res.data.ciudades && esEcuador) {
                setCiudades(res.data.ciudades);
            }
            reset(generic.renewValues(_item, omodel.model));
            setDialogCliente(true);
        });
    };

    const deleteItem = () => {
        confirmDialog({
            group: 'confirmar',
            message: '¿Está seguro de eliminar el cliente?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                monitoreoService.eliminar(item?.id, 'monitoreo/cliente/eliminar').then(res => {
                    generic.funcSuccess(res, toast);
                    loadLazyData();
                }).catch(err => {
                    generic.funcDeleteError(err, toast);
                });
            }
        });
    };

    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar && siOpcion('monitoreo-cliente-editar-cliente'))
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { edit() } });
        if (permss?.eliminar && siOpcion('monitoreo-cliente-eliminar-cliente'))
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { deleteItem() } });

        return [{ label: 'Opciones', items: items }];
    }

    const customDialogHeader = () => {
        return (
            <div>
                <i className="pi pi-user-edit icon-header" />
                <span className="title-header">
                    {getValues('id') == null ? " Nuevo Cliente" : " Editar Cliente"}
                </span>
            </div>
        );
    }

    const calcularIngresoNeto = () => {
        const ingreso = getValues('ingreso_mensual') || 0;
        const egreso = getValues('egreso_mensual') || 0;
        setValue('ingreso_mensual_neto', ingreso - egreso);
    };

    const calcularPatrimonio = () => {
        const activo = getValues('activo') || 0;
        const pasivo = getValues('pasivo') || 0;
        setValue('patrimonio', activo - pasivo);
    };

    const onChangePais = (e) => {
        setValue('pais_id', e.value);
        setEcuador(e.value === ecuadorId);
    };

    const onChangeProvincia = (e) => {
        setValue('provincia_id', e.value);
        if (e?.value) {
            catalogoSrv.getCatalogosId(e.value).then(res => {
                setCiudades(res.data);
            });
        }
    };

    const exportar = (ttipo) => {
        setTipo(ttipo);
        setDialogReporte(true);
        setInicio(null);
        setFin(null);
    }

    const generarReporte = () => {
        if (!inicio || !fin) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Seleccione el rango de fechas', life: 6000 });
            return;
        } else if (inicio > fin) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'La fecha de inicio debe ser menor a la fecha de fin', life: 6000 });
            return;
        } else if (generic.fechasDiferenciaEnDias(inicio, fin) > diasMaxDescargaReporte) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: `El rango de fechas no puede superar los ${diasMaxDescargaReporte} días`, life: 6000 });
            return;
        }
        const _inicio = generic.dateToString(inicio);
        const _fin = generic.dateToString(fin);
        setLoadPdf(tipo === 'pdf');
        setLoadExcel(tipo === 'xlsx');
        if (tipo === 'xlsx') {
            monitoreoService.generarDocumento(`monitoreo/cliente/reporte/${tipo}/${_inicio}/${_fin}`, { rol: getRol() }).then(res => {
                generic.downloadPdf(res.data, 'Listado_clientes.xlsx');
            }).catch((err) => {
                generic.funcErrorHibrida(err, toast, setError);
            }).finally(() => {
                setLoadPdf(false);
                setLoadExcel(false);
            });
        } else {
            monitoreoService.consultarInfo(`monitoreo/cliente/reporte/${tipo}/${_inicio}/${_fin}`, { rol: getRol() }).then(res => {
                generarDetalleCliente(res.data.detalle, res.data.info);
            }).catch((err) => {
                generic.funcErrorHibrida(err, toast, setError);
            }).finally(() => {
                setLoadPdf(false);
                setLoadExcel(false);
            });
        }
    };

    const descargarPlantillaCargaMasiva = () => {
        setLoadExcel(true);
        monitoreoService.generarDocumento('monitoreo/cliente/descargar-plantilla').then((res) => {
            generic.downloadPdf(res.data, 'plantilla_clientes_transacciones.xlsx');
            toast.current.show({ severity: 'success', summary: 'Archivo', detail: `Plantilla descargada`, life: 6000 });
        }).catch((error) => {
            generic.funcErrorHibrida(error, toast, setError);
        }).finally(() => {
            setLoadExcel(false);
        });
    };

    // Función para capturar el archivo seleccionado
    const onFileSelect = (e) => {
        setArchivoMasivo(e.files[0]);
    };


    // Función para enviar al backend
    const procesarCargaMasiva = () => {
        if (!archivoMasivo) {
            toast.current.show({ severity: 'warn', summary: 'Atención', detail: 'Debe seleccionar un archivo Excel.', life: 4000 });
            return;
        }
        if ((esAdmin || (catalogos.catalogo_empresas && catalogos.catalogo_empresas.length > 1)) && !empresaSelUpload) {
            toast.current.show({ severity: 'warn', summary: 'Atención', detail: 'Debe seleccionar una empresa para la carga masiva.', life: 4000 });
            return;
        }
        setLoadUpload(true);
        const formData = new FormData();
        formData.append('file', archivoMasivo);
        formData.append('tipo', 'transaccion');
        if (empresaSelUpload) {
            const empresaId = typeof empresaSelUpload === 'object' ? empresaSelUpload.value : empresaSelUpload;
            formData.append('empresa', empresaId);
        }

        monitoreoService.subirArchivoHibrido('monitoreo/cliente/carga-masiva', formData).then((res) => {
            const headerConsulta = res.headers['x-consulta']; // Cabecera especial cuando llega un blob
            if (!headerConsulta) {
                // NO HAY CABECERA -> Es un JSON de éxito (sendResponse)
                res.data.text().then(text => {
                    const info = JSON.parse(text);
                    toast.current.show({ severity: 'success', summary: 'Éxito', detail: info.message || 'Carga masiva procesada correctamente', life: 6000 });
                    cerrarDialogUpload();
                    tablaEstado.refreshData();
                });
            } else {
                // SÍ HAY CABECERA -> El backend nos envió el Excel de errores
                toast.current.show({ severity: 'error', summary: 'Errores detectados', detail: 'El archivo contiene errores, se descargará el reporte.', life: 6000 });
                // Forzamos la descarga del blob en el navegador
                const urlBlob = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = urlBlob;
                link.setAttribute('download', headerConsulta); // Usamos el nombre que vino en la cabecera
                document.body.appendChild(link);
                link.click();
                link.remove();
            }
        }).catch((error) => {
            generic.funcErrorHibrida(error, toast, setError);
        }).finally(() => {
            setLoadUpload(false);
        });
    };

    const cerrarDialogUpload = () => {
        setDialogUpload(false);
        setArchivoMasivo(null);
        setEmpresaSelUpload(null);
        if (fileUploadRef.current) {
            fileUploadRef.current.clear();
        }
    };

    const rightTool = () => (
        <div className="flex align-items-center gap-4">
            <div className="flex align-items-center gap-2 border-right-1 surface-border pr-4">
                <Button onClick={descargarPlantillaCargaMasiva} className="p-button-secondary" tooltip="1. Descargar plantilla" tooltipOptions={{ position: 'top' }} icon="pi pi-download" loading={loadExcel} />
                <Button onClick={() => setDialogUpload(true)} className="p-button-info" tooltip="2. Subir plantilla llena" tooltipOptions={{ position: 'top' }} icon="pi pi-cloud-upload" />
            </div>
            <div className="flex align-items-center gap-2">
                <Button onClick={() => exportar('pdf')} className="p-button-danger" tooltip="Exportar clientes a PDF" tooltipOptions={{ position: 'top' }} icon="pi pi-file-pdf" loading={loadPdf} disabled={loadExcel} />
                <Button onClick={() => exportar('xlsx')} className="p-button-success" tooltip="Exportar clientes a Excel" tooltipOptions={{ position: 'top' }} icon="pi pi-file-excel" loading={loadExcel} disabled={loadPdf} />
            </div>
        </div>
    );

    const accionesTemplate = (rowData) => {
        return (
            <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" aria-controls="popup_menu" aria-haspopup
                onClick={(event) => { setItem(rowData); menuRef.current.toggle(event); }} />
        );
    };

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '6rem', textAlign: 'center' }} frozen alignFrozen="right" />
    );

    const generarDetalleCliente = (detalles, info) => {
        const body = [];
        let contador = 1;

        // Existe un valor para el reporte?
        const incluirTipoPersona = detalles.some(t => t.tipo_persona)

        detalles.forEach(cliente => {
            const fila = [
                contador++,
                cliente.nombres,
                cliente.empresa,
                cliente.identificacion,
                cliente.pais,
                cliente.provincia || '-',
                cliente.ciudad,
                cliente.direccion,
            ];
            if (incluirTipoPersona) fila.push(cliente.tipo_persona || '-');
            fila.push(
                cliente.ingreso_mensual,
                cliente.egreso_mensual,
                cliente.ingreso_mensual_neto,
                cliente.activo,
                cliente.pasivo,
                cliente.patrimonio,
                cliente.fecha
            )

            body.push(fila);
        });

        const docDefinition = omodel.template(body, info, { incluirTipoPersona });
        pdfMake.createPdf(docDefinition).download('Listado_clientes.pdf');
    }

    const limpiarArchivo = () => {
        setArchivoMasivo(null);
        if (fileUploadRef.current) {
            fileUploadRef.current.clear();
        }
    };

    const siOpcion = (strOpcion) => {
        return permss?.actualizar && (funcionalidades.includes('PRELAFIT') || funcionalidades.includes(strOpcion));
    };

    return (
        <>
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu" />
            <ConfirmDialog group="confirmar" className="dialog-personalizado" />
            <Toast ref={toast} />
            <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                <Toolbar className="mb-4" start={generic.leftToolbarTemplate(openNew, 'Nuevo cliente', permss)} end={rightTool} />
                <TablaDinamica modelo={omodel.model} estadoTabla={tablaEstado} datos={tablaEstado.data} totalRegistros={tablaEstado.totalRecords} catalogos={catalogos} dataKey="id" acciones={ColumnaAcciones} />
            </Card>
            <Dialog visible={dialogCliente} header={customDialogHeader} modal className="p-fluid dialog-personalizado" onHide={() => setDialogCliente(false)} style={{ minWidth: '700px', maxWidth: '800px' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Stepper ref={stepperRef} style={{ flexBasis: '100%' }} linear={getValues('id') == null} headerPosition="right">
                        <StepperPanel header={"Información Personal"}>
                            <div className="formgrid grid">
                                {inText('nombres', { icon: 'pi pi-user', iconPosition: 'left' }, 6)}
                                {inDrop('tipo_identificacion', catalogos?.tipo_identificacion, {}, 6)}
                                {inText('identificacion', { icon: 'pi pi-id-card' }, 6)}
                                {inDrop('empresa', catalogos?.catalogo_empresas, {}, 6)}
                            </div>
                            <div className="flex pt-4 justify-content-between" style={{ flexDirection: 'row-reverse' }}>
                                <Button label="Siguiente" icon="pi pi-arrow-right" iconPos="right"
                                    onClick={() => {
                                        trigger().then(valid => { if (valid) stepperRef.current.nextCallback(); });
                                    }} style={{ minWidth: '140px', width: 'auto' }}
                                />
                                {getValues('id') !== null && (
                                    <Button label="Guardar" icon="pi pi-save" type="submit" loading={load} severity="help" style={{ minWidth: '140px', width: 'auto' }} />
                                )}
                            </div>
                        </StepperPanel>

                        <StepperPanel header={"Ubicación del Cliente"}>
                            <div className="formgrid grid">
                                {inDrop('pais_id', catalogos?.paises, { lab: 'label', chn: onChangePais }, 6)}
                                {ecuador && inDrop('provincia_id', catalogos?.provincias, { lab: 'label', chn: onChangeProvincia }, 6)}
                                {ecuador && inDrop('ciudad_id', ciudades.map(c => ({ label: c.nombre, value: c.cat_id })), { lab: 'label' }, 6)}
                                {!ecuador && inText('ciudad', {}, 6)}
                                {inText('direccion', {}, 12)}
                            </div>

                            <div className="flex pt-4 justify-content-between">
                                <Button label="Atrás" severity="secondary" icon="pi pi-arrow-left" onClick={() => stepperRef.current.prevCallback()} style={{ minWidth: '140px', width: 'auto' }} />
                                {getValues('id') !== null && (
                                    <Button label="Guardar" icon="pi pi-save" type="submit" loading={load} severity="help" style={{ minWidth: '140px', width: 'auto' }} />
                                )}
                                <Button label="Siguiente" icon="pi pi-arrow-right" iconPos="right"
                                    onClick={() => {
                                        trigger().then(valid => { if (valid) stepperRef.current.nextCallback(); });
                                    }} style={{ minWidth: '140px', width: 'auto' }}
                                />
                            </div>
                        </StepperPanel>

                        <StepperPanel header={"Información Financiera"}>
                            <div className="formgrid grid gap-4">
                                <div className="col-12">
                                    <Card header={<span className="text-base font-semibold text-color">Ingresos y Egresos</span>}>
                                        <div className="formgrid grid">
                                            {inNumber('ingreso_mensual', 2, false, { icon: 'pi pi-dollar', func: calcularIngresoNeto }, 3)}
                                            <div className="col-1 flex justify-content-center align-items-center text-xl">-</div>
                                            {inNumber('egreso_mensual', 2, false, { icon: 'pi pi-dollar', func: calcularIngresoNeto }, 3)}
                                            <div className="col-1 flex justify-content-center align-items-center text-xl">=</div>
                                            {inNumber('ingreso_mensual_neto', 2, false, { icon: 'pi pi-dollar', min: 'nulo', disabled: true }, 4)}
                                        </div>
                                    </Card>
                                </div>
                                <div className="col-12">
                                    <Card header={<span className="text-base font-semibold text-color">Balance Patrimonial</span>}>
                                        <div className="formgrid grid">
                                            {inNumber('activo', 2, false, { icon: 'pi pi-dollar', func: calcularPatrimonio }, 3)}
                                            <div className="col-1 flex justify-content-center align-items-center text-xl">-</div>
                                            {inNumber('pasivo', 2, false, { icon: 'pi pi-dollar', func: calcularPatrimonio }, 3)}
                                            <div className="col-1 flex justify-content-center align-items-center text-xl">=</div>
                                            {inNumber('patrimonio', 2, false, { icon: 'pi pi-dollar', min: 'nulo', disabled: true }, 4)}
                                        </div>
                                    </Card>
                                </div>
                            </div>
                            <div className="flex pt-4 justify-content-between">
                                <Button label="Atrás" severity="secondary" icon="pi pi-arrow-left" onClick={() => stepperRef.current.prevCallback()} style={{ minWidth: '140px', width: 'auto' }} />
                                <Button label="Guardar" icon="pi pi-save" type="submit" loading={load} style={{ minWidth: '140px', width: 'auto' }} />
                            </div>
                        </StepperPanel>
                    </Stepper>
                </form>
            </Dialog>

            <Dialog visible={dialogReporte} header="Generar Reporte" modal className="p-fluid dialog-personalizado" onHide={() => setDialogReporte(false)} style={{ maxWidth: '460px' }}>
                <div className="p-4">
                    <div className="flex align-items-start gap-3 mb-4">
                        <div className={`flex-shrink-0 flex align-items-center justify-content-center border-round-lg ${tipo === 'pdf' ? 'bg-red-50' : 'bg-green-50'}`} style={{ width: '52px', height: '52px' }}>
                            <i className={`text-3xl ${tipo === 'pdf' ? 'pi pi-file-pdf text-red-700' : 'pi pi-file-excel text-green-700'}`}></i>
                        </div>
                        <div>
                            <h4 className="m-0 mb-1 text-900">
                                Exportar Reporte a {tipo === 'pdf' ? 'PDF' : 'Excel'}
                            </h4>
                            <p className="m-0 text-color-secondary line-height-3 text-sm">
                                Genera un documento de exportación con los datos de clientes entre las fechas seleccionadas a continuación.
                            </p>
                        </div>
                    </div>
                    <div className="formgrid grid mb-3">
                        <div className="field col-12 md:col-6 mb-0">
                            <label htmlFor="inicio" className="font-bold block mb-2 text-sm">
                                Fecha Inicio *
                            </label>
                            <Calendar id="inicio" value={inicio} onChange={(e) => setInicio(e.value)} showIcon readOnlyInput placeholder="Seleccionar..." />
                        </div>

                        <div className="field col-12 md:col-6 mb-0">
                            <label htmlFor="fin" className="font-bold block mb-2 text-sm">
                                Fecha Fin *
                            </label>
                            <Calendar id="fin" value={fin} onChange={(e) => setFin(e.value)} showIcon readOnlyInput placeholder="Seleccionar..." />
                        </div>
                    </div>
                    <div className="flex align-items-start gap-2 p-3 border-1 border-blue-200 border-round mb-4 bg-blue-50">
                        <i className="pi pi-info-circle text-blue-600 mt-1 text-lg"></i>
                        <span className="text-blue-800 text-sm line-height-3">
                            El rango entre ambas fechas no puede superar los <strong>{diasMaxDescargaReporte} días de diferencia</strong>.
                        </span>
                    </div>
                    <div className="flex gap-2 w-full mt-2">
                        <Button label="Cancelar" icon="pi pi-times" className="p-button-text p-button-secondary w-full" onClick={() => { setDialogReporte(false); }} disabled={loadPdf || loadExcel} />
                        <Button label={`Generar ${tipo === 'pdf' ? 'PDF' : 'Excel'}`} icon={`pi ${tipo === 'pdf' ? 'pi-file-pdf' : 'pi-file-excel'}`} className={`w-full ${tipo === 'pdf' ? 'p-button-danger' : 'p-button-success'}`} onClick={() => generarReporte()} loading={loadPdf || loadExcel} disabled={!inicio || !fin} />
                    </div>
                </div>
            </Dialog>
            <Dialog visible={dialogUpload} header="Carga Masiva de Clientes y Transacciones" modal className="p-fluid dialog-personalizado" onHide={cerrarDialogUpload} style={{ maxWidth: '460px' }}>
                <div className="p-4">
                    <div className="flex align-items-start gap-3 mb-4">
                        <div className="flex-shrink-0 flex align-items-center justify-content-center border-round-lg" style={{ width: '52px', height: '52px', background: 'var(--green-50)' }}>
                            <i className="pi pi-file-excel text-3xl" style={{ color: 'var(--green-700)' }}></i>
                        </div>
                        <div>
                            <h4 className="m-0 mb-1 text-900">Importar datos</h4>
                            <p className="m-0 text-color-secondary line-height-3 text-sm">
                                Selecciona el archivo Excel previamente llenado usando la plantilla oficial.
                            </p>
                        </div>
                    </div>

                    {(esAdmin || (catalogos.catalogo_empresas && catalogos.catalogo_empresas.length > 1)) && (
                        <div className="field mb-4">
                            <label className="font-bold block mb-2 text-sm">Empresa *</label>
                            {esAdmin ? (
                                <FiltroUnicoAutocomplete id="ac-empresa-up" value={empresaSelUpload} onChange={setEmpresaSelUpload} fetchData={buscarSugerenciasEmpresa} placeholder="Buscar empresa..." />
                            ) : (
                                <FiltroUnicoCatalogoFijo value={empresaSelUpload} options={catalogos.catalogo_empresas} onChange={setEmpresaSelUpload} placeholder="Seleccione Empresa" icon="pi pi-building" />
                            )}
                        </div>
                    )}

                    {!archivoMasivo ? (
                        <FileUpload ref={fileUploadRef} mode="basic" customUpload={true} uploadHandler={() => { }} accept=".xls,.xlsx"
                            maxFileSize={10000000} onSelect={onFileSelect} auto={false} chooseLabel="Seleccionar Archivo Excel"
                            chooseOptions={{ icon: 'pi pi-fw pi-upload', className: 'p-button-outlined p-button-secondary w-full border-dashed', }}
                            className="mb-4 w-full" />
                    ) : (
                        <div className="flex align-items-center justify-content-between p-3 border-1 border-green-300 border-round mb-4 bg-green-50">
                            <div className="flex align-items-center gap-3">
                                <i className="pi pi-file-excel text-green-600 text-2xl"></i>
                                <div className="flex flex-column">
                                    <span className="text-green-800 font-medium text-sm">
                                        {archivoMasivo.name}
                                    </span>
                                    <span className="text-xs text-green-600">
                                        {(archivoMasivo.size / 1024 / 1024).toFixed(2)} MB
                                    </span>
                                </div>
                            </div>
                            <Button icon="pi pi-times" className="p-button-rounded p-button-danger p-button-text p-button-sm m-0 p-2" onClick={limpiarArchivo} tooltip="Quitar archivo" tooltipOptions={{ position: 'top' }} disabled={loadUpload} type="button" />
                        </div>
                    )}

                    <div className="flex gap-2 w-full mt-2">
                        <Button label="Cancelar" icon="pi pi-times" className="p-button-text p-button-secondary w-full" onClick={cerrarDialogUpload} disabled={loadUpload} />
                        <Button label="Procesar Excel" icon="pi pi-cloud-upload" className="p-button-primary w-full" onClick={procesarCargaMasiva} loading={loadUpload} disabled={!archivoMasivo} />
                    </div>
                </div>
            </Dialog>
        </>
    )
}
